import { getCurrentSeasonInfo } from '../components/dashboards/utils/footballLeagueUtils';

/**
 * Resolve the correct API season for a given football league.
 *
 * The Football API (api-football.com v3) represents seasons as 4-digit years:
 *  - European leagues with cross-year seasons (e.g. 2025-2026 EPL) → API season "2025"
 *  - South American leagues with single-year seasons (e.g. 2026 Brasileirão) → API season "2026"
 *
 * When no league is specified, this function returns null so the API can
 * return fixtures for all active seasons on the requested date — avoiding
 * the problem of filtering out fixtures from leagues whose API season
 * identifier doesn't match a single hard-coded year.
 *
 * @param {string|number|null} leagueId - League ID, or falsy for "all leagues"
 * @returns {string|null} Season string to send to the API, or null to omit the parameter
 */
export const resolveSeasonForLeague = (leagueId) => {
  // When no specific league is selected, don't constrain by season.
  // The API returns all fixtures for the given date across all active seasons.
  if (!leagueId) {
    return null;
  }

  // Look up the configured season for this league
  const seasonInfo = getCurrentSeasonInfo(Number(leagueId));

  if (seasonInfo?.current && seasonInfo.season) {
    return String(seasonInfo.season);
  }

  // If the league isn't in our config (e.g. newly added leagues),
  // don't send season — let the API return the active season's data.
  return null;
};
